import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

export function Divider({ className, titleClassName, textClassName, title, text, border }) {
  const dividerClassName = classnames(
    'ewc-divider',
    border && `ewc-divider--border-${border}`,
    { 'ewc-divider--text': text },
    className,
  );

  const titleClassNames = classnames('ewc-divider__title', { 'ewc-divider__title--text': text }, titleClassName);

  return (
    <div className={dividerClassName}>
      <div className={titleClassNames}>{title}</div>

      {text && <div className={classnames('ewc-divider__text', textClassName)}>{text}</div>}
    </div>
  );
}

Divider.propTypes = {
  border: PropTypes.oneOf(['top', 'bottom']),
  className: PropTypes.string,
  text: PropTypes.string,
  textClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
};
